<template>
  <keep-alive>
    <NewgameWrapper
      ref="newGameWrapper"
      :location="3"
      :circleId="circleId"
      :isFirstEnter="isFirstEnter"
    >
      <div :class="$style.box">
        <!-- 帖子编辑区域 -->
        <!-- <IssueTopicField
        v-if="showTopicField"
        :circleId="circleId"
        @closeIssueTopicField="closeIssueTopicField"
      /> -->
        <TopHeader headerTitle="游戏圈" />
        <!-- 悬浮回到顶部按钮、发布帖子按钮 -->
        <div :class="$style['suspend-btn']">
          <img
            v-show="showFixedTabs"
            :src="`${$cdnUrl}/refresh.png`"
            alt="回到顶部"
            @click="scrollToTop"
          />
          <!-- <img :src="`${$cdnUrl}/add.png`" alt="添加帖子" @click="addTopic" /> -->
        </div>
        <!-- 2021.08.11新增 帝王荣耀圈子（id：20）专属活动弹窗 -->
        <SignDialog v-if="SignDialogShow" @close="closeSignDialog"></SignDialog>
        <!-- 2021.10.13新增 逍遥三国（id：24）专属活动弹窗 -->
        <DialogEnter v-if="DialogEnterShow" @close="closeSignDialog"></DialogEnter>
        <!-- 2021.11.10 1001傲世龙城平台活动（id：26）专属活动弹窗 -->
        <DialogLottery v-if="DialogLotteryShow" @close="closeSignDialog"></DialogLottery>
        <!-- 2022.02.15新增 搜索弹窗 -->
        <Search
          ref="search"
          :circleId="circleId"
          v-if="searchShow"
          @cancelSearch="cancelSearch"
        ></Search>
        <!-- 顶部游戏圈信息-->
        <Scroll
          ref="scroll"
          :class="$style.wrapper"
          :pullup="true"
          :pulldown="true"
          :pullDownThreshold="40"
          :listenScroll="true"
          @scroll="handleScroll"
          @bsPullingUp="bsPullingUp"
          @bsPullingDown="bsPullingDown"
        >
          <div :class="$style.content">
            <div :class="$style.refresh">加载中...</div>
            <NewgameWrapperTopbanner
              v-if="hasTopBannerList"
              :class="$style['top-banner']"
              :topBannerList="topBannerList"
              :heightAuto="true"
            />
            <div
              :class="$style.circle"
              :style="`background-image: url(${`${
                !hasTopBannerList ? circleInfo.background : ''
              }`})`"
            >
              <div :class="$style['circle-content']">
                <div :class="$style['circle-info']">
                  <img v-lazy="circleInfo.images" alt="游戏圈icon" />
                  <div :class="$style['circle-account']">
                    <p>{{ circleInfo.name }}</p>
                    <div v-if="isBindAccount">
                      <p>游戏账号：{{ userInfo.game_account }}</p>
                      <!-- <div>需要修改</div> -->
                      <p v-if="userInfo.game_name">
                        区服：{{ handleGameName(userInfo.game_name) }}
                      </p>
                      <p v-if="userInfo.role_name">角色名：{{ userInfo.role_name }}</p>
                    </div>
                    <div v-else :class="$style['no-bind-account']">
                      <span>绑定角色信息</span>
                      <Button class="hm-small-btn" type="info" @click="bindAccount"
                        >前往绑定</Button
                      >
                    </div>
                  </div>
                </div>
                <ul :class="$style['circle-navbar']">
                  <li
                    v-for="(item, index) in circleNavbarList"
                    :key="item.id"
                    :class="index && index % 3 === 0 && $style.noMargin"
                    @click="handleLinkTo(item)"
                  >
                    <img :src="item.images" alt="导航icon" />
                    <p>{{ item.name }}</p>
                  </li>
                </ul>
              </div>
            </div>
            <!-- 帖子列表部分 -->
            <div :class="$style.list">
              <div :class="$style.tabs">
                <Tabs
                  v-if="!showFixedTabs"
                  @changeActiveTab="changeActiveTab"
                  @changeSortType="changeSortType"
                  @search="search"
                />
              </div>
              <!-- 置顶列表 -->
              <ul v-if="hasTopTopicList" :class="$style['top-topic-list']">
                <li v-for="item in topTopicList" :key="item.id" @click="linkToDetail(item.id)">
                  <span :class="$style.tag">置顶</span>
                  <!-- 2021.10.20临时加 需要删除的话删除 style -->
                  <p :class="item.mark === 1 ? $style.mark : ''">{{ item.title }}</p>
                </li>
              </ul>
              <!-- 帖子贴列表 -->
              <div :class="$style['topic-list']">
                <TopicListItem
                  v-for="item of topicList"
                  :key="item.id"
                  :topicItem="item"
                  :isNew="activeTabValue == 'is_new'"
                  @click.native="linkToDetail(item.id)"
                />
              </div>
            </div>
            <div v-show="noMoreTopic" :class="$style['no-more-topic']">—— 我是有底线的 ——</div>
          </div>
          <!-- 固定tabs -->
          <div v-if="showFixedTabs" :class="$style['fix-tabs']">
            <Tabs
              :isFixedTab="true"
              @changeActiveTab="changeActiveTab"
              @changeSortType="changeSortType"
              @search="search"
            />
          </div>
        </Scroll>
      </div>
    </NewgameWrapper>
  </keep-alive>
</template> 

<script>
import NewgameWrapper from '_c/NewgameWrapper';
import NewgameWrapperTopbanner from '_c/NewgameWrapperTopbanner';
import Scroll from '_c/Scroll';
import CircleBaseBox from '_c/CircleBaseBox';
import TopHeader from '_c/TopHeader';
import Tabs from './components/Tabs';
import TopicListItem from './components/TopicListItem';
import IssueTopicField from '_c/IssueTopicField';
import Search from './components/Search.vue';
import { Toast, Dialog } from 'vant';
import {
  getCircleInfo,
  getCircleNavbarList,
  getTopTopicList,
  getNewTopicList,
  getHotTopicList,
  getEssenceTopicList,
} from '@/api/gameCircle';
import { reportData } from '@/api/report';
import { signInLotteryInfo, promoteRechargeActInfo, signInLotteryActInfo } from '@/api/activity';
import { mapActions, mapState, mapMutations } from 'vuex';
import { localLinkJump } from '@/utils/index';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
dayjs.extend(duration);
import SignDialog from '../activity/components/imperialGlory/SignDialog.vue';
import DialogEnter from '../activity/components/freeKingdoms/DialogEnter.vue';
import DialogLottery from '../activity/components/dragonCity/DialogLottery.vue';
export default {
  components: {
    NewgameWrapper,
    NewgameWrapperTopbanner,
    Scroll,
    CircleBaseBox,
    TopHeader,
    Tabs,
    TopicListItem,
    IssueTopicField,
    Dialog,
    SignDialog,
    DialogEnter,
    DialogLottery,
    Search,
  },
  data() {
    return {
      circleInfo: {}, // 游戏圈信息
      circleNavbarList: [], // 游戏圈导航
      showFixedTabs: false, // 显示固定tabs
      topTopicList: [], // 置顶帖子列表
      topicList: [], // 主要帖子帖子列表
      currentPage: 1, // 帖子列表当前page
      sortType: 0, //0 按更新时间排序 1 发帖时间排序
      activeTabValue: 'is_new', // 帖子类型（最新、最热、精华）
      noMoreTopic: false, // 加载帖子列表为空时显示
      showTopicField: false,
      bsScrollTop: 0, // better-scroll滚动的距离
      isFirstEnter: false, // 判断是否是第一次进入
      showNewgameWrapper: true,
      SignDialogShow: false, // 帝王荣耀活动弹窗显示与否
      DialogEnterShow: false, // 逍遥三国活动弹窗显示与否
      DialogLotteryShow: false, // 傲世龙城活动弹窗显示与否
      searchShow: false, // 搜索弹窗是否显示
    };
  },
  computed: {
    ...mapState('account', {
      userInfo: (state) => state.userInfo, // 当前用户信息
    }),
    ...mapState('gameCircleCenter', {
      topBannerList: (state) => state.topBannerList,
    }),
    // 判断是否注册论坛
    isRegister() {
      let flag = this.userInfo.forum_user_id != 0 ? true : false;
      return flag;
    },
    hasTopBannerList() {
      return this.topBannerList.length > 0 ? true : false;
    },
    // 游戏圈id
    circleId() {
      return this.$route.query.circleId;
    },
    // 判断是否绑定游戏账号
    isBindAccount() {
      let flag = this.userInfo.game_user_id != 0 ? true : false;
      return flag;
    },
    hasTopTopicList() {
      return this.topTopicList.length ? true : false;
    },
  },
  beforeRouteEnter(to, from, next) {
    if (from.name == 'gameCircle.details') {
      to.meta.isBack = true;
    }
    let hasBrowsingTime = sessionStorage.getItem('browsingTime');
    if (hasBrowsingTime) {
      next((vm) => {
        if (to.query.noSearch == '1') {
          const _url = window.location.href.split('&noSearch')[0];
          window.history.replaceState({}, 0, _url);
          vm.cancelSearch();
        }
      });
    } else {
      sessionStorage.setItem('browsingTime', dayjs().valueOf());
      next((vm) => {
        if (to.query.noSearch == '1') {
          const _url = window.location.href.split('&noSearch')[0];
          window.history.replaceState({}, 0, _url);
          vm.cancelSearch();
        }
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    let startTime = sessionStorage.getItem('browsingTime');
    let endTime = dayjs().valueOf();
    let duringMinutes = dayjs.duration(endTime - startTime).minutes();
    if (duringMinutes >= 2) {
      reportData({
        type: 11,
        circle_id: this.circleId,
      });
    }
    sessionStorage.removeItem('browsingTime');
    next();
  },
  created() {
    this.showProhibitionDialog();
    localStorage.removeItem('tabValue');
    localStorage.removeItem('sortType');
    this.getCircleInfo();
    this.getCircleNavbarList();
    this.getTopTopicList();
    this.getTopicList();
    this.isFirstEnter = true;
    // this.getSignInLotteryInfo();
    // this.getpromoteRechargeInfo();
    this.getSignInLotteryActInfo();
  },
  mounted() {
    reportData({
      type: 3,
      data_type: 4, // 具体圈子页面加载
      circle_id: this.circleId,
    });
    this.$bus.$on('getTopicList', () => {
      this.getTopicList();
    });
  },
  activated() {
    this.showProhibitionDialog();
    // 当不是首次进入页面，且不是从详情页返回的时候初始化并获取数据
    if (!this.$route.meta.isBack && !this.isFirstEnter) {
      reportData({
        type: 3,
        data_type: 4, // 具体圈子页面加载
        circle_id: this.circleId,
      });
      this.initData();
    }
    this.$route.meta.isBack = false;
    this.isFirstEnter = false;
  },
  beforeDestroy() {
    this.$bus.$off('getTopicList');
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_SHOW_LOADING: 'CHANGE_SHOW_LOADING',
      CHANGE_BIND_GAME: 'CHANGE_BIND_GAME',
      CHANGE_REGISTER_DIALOG: 'CHANGE_REGISTER_DIALOG',
    }),
    initData() {
      localStorage.removeItem('tabValue');
      localStorage.removeItem('sortType');
      this.activeTabValue = 'is_new';
      this.sortType = 0;
      this.showFixedTabs = false;
      this.circleInfo = {};
      this.circleNavbarList = [];
      this.topTopicList = [];
      this.topicList = [];
      this.currentPage = 1;
      this.noMoreTopic = false;
      this.showTopicField = false;
      this.$nextTick(() => {
        this.getCircleInfo();
        this.getCircleNavbarList();
        this.getTopTopicList();
        this.getTopicList();
      });
    },
    // 2022.02.15新增，搜索历史记录功能
    search() {
      this.searchShow = true;
      reportData({
        type: 15,
        data_type: 1,
        circle_id: this.circleId,
      });
      this.$nextTick(() => {
        this.$refs.search.showSearch();
      });
    },
    cancelSearch() {
      this.searchShow = false;
    },
    // 获取帝王荣耀活动页信息
    async getSignInLotteryInfo() {
      const { data, code } = await signInLotteryInfo();
      if (code !== 1) return;
      // 获取上次打开时间，是否在一天内
      const oldDate = localStorage.getItem('sign-in-date') || ''; // 之前缓存的日期
      const newDate = new Date(); // 现在的日期
      if (oldDate !== '' && this.datesAreOnSameDay(new Date(oldDate), newDate)) return;
      this.SignDialogShow = data.state === 1 && this.circleId == 20;
    },
    // 获取逍遥三国活动页信息
    async getpromoteRechargeInfo() {
      const { data, code } = await promoteRechargeActInfo();
      if (code !== 1) return;
      // 获取上次打开时间，是否在一天内
      const oldDate = localStorage.getItem('promote-date') || ''; // 之前缓存的日期
      const newDate = new Date(); // 现在的日期
      if (oldDate !== '' && this.datesAreOnSameDay(new Date(oldDate), newDate)) return;
      this.DialogEnterShow = data.info.state === 1 && this.circleId == 24;
    },
    // 获取1001傲世龙城平台活动页信息
    async getSignInLotteryActInfo() {
      const { data, code } = await signInLotteryActInfo();
      if (code !== 1) return;
      // 获取上次打开时间，是否在一天内
      const oldDate = localStorage.getItem('lottery-date') || ''; // 之前缓存的日期
      const newDate = new Date(); // 现在的日期
      if (oldDate !== '' && this.datesAreOnSameDay(new Date(oldDate), newDate)) return;
      this.DialogLotteryShow = data.info.state === 1 && this.circleId == 26;
    },
    // 判断是否为同一天
    datesAreOnSameDay(first, second) {
      return (
        first.getFullYear() === second.getFullYear() &&
        first.getMonth() === second.getMonth() &&
        first.getDate() === second.getDate()
      );
    },
    closeSignDialog() {
      this.SignDialogShow = false;
      this.DialogEnterShow = false;
      this.DialogLotteryShow = false;
    },
    // 获取游戏圈信息
    async getCircleInfo() {
      const r = await getCircleInfo({ game_circle_id: this.circleId });
      this.circleInfo = { ...r.data };
    },
    // 获取游戏圈导航
    async getCircleNavbarList() {
      const r = await getCircleNavbarList({ game_circle_id: this.circleId });
      this.circleNavbarList = [...r.data];
    },
    // 获取游戏圈置顶列表
    async getTopTopicList() {
      const r = await getTopTopicList({ game_circle_id: this.circleId });
      this.topTopicList = [...r.data];
    },
    // 获取帖子列表
    async getTopicList(type) {
      this.CHANGE_SHOW_LOADING(true);
      let params = {
        limit: 10,
        page: this.currentPage,
        game_circle_id: this.circleId,
        sort_type: this.sortType,
      };
      let r = {};
      try {
        switch (this.activeTabValue) {
          case 'is_new':
            r = await getNewTopicList(params);
            break;
          case 'is_hot':
            r = await getHotTopicList(params);
            break;
          case 'is_essence':
            r = await getEssenceTopicList(params);
            break;
          default:
            break;
        }
      } catch (error) {
        this.CHANGE_SHOW_LOADING(false);
      }
      // 加载列表为空
      if (!r.data.length) {
        this.noMoreTopic = true;
      }
      if (this.currentPage == 1) {
        this.topicList = [...[]];
      }
      this.topicList = this.topicList.concat([...r.data]);
      this.CHANGE_SHOW_LOADING(false);
      // if (type == 'pullDown') {
      //   Toast('已为您加载最新内容');
      // }
      setTimeout(() => {
        this.$refs.scroll && this.$refs.scroll.refresh();
      }, 10);
    },
    // 点击游戏圈导航
    handleLinkTo(item) {
      reportData({
        type: 6,
        navigation_id: item.id,
      });
      if (item.url.includes(this.$route.fullPath)) {
        Toast('无法跳转到相同路由');
        return;
      }
      if (item.url_type == 2) {
        setTimeout(() => {
          window.location.href = item.url;
        }, 10);
        return;
      }
      localLinkJump(item.url);
    },
    // 跳转到帖子详情页
    linkToDetail(id) {
      this.$router.push({ name: 'gameCircle.details', query: { circleId: this.circleId, id } });
    },
    // 切换tab
    changeActiveTab(value) {
      this.activeTabValue = value;
      this.currentPage = 1;
      this.noMoreTopic = false;
      setTimeout(() => {
        this.getTopicList();
      }, 10);
    },
    // 切换更新方式
    changeSortType(type) {
      this.sortType = type;
      this.currentPage = 1;
      setTimeout(() => {
        this.getTopicList();
      }, 10);
    },
    // 上拉加载
    bsPullingUp() {
      this.currentPage++;
      setTimeout(() => {
        this.getTopicList();
      }, 10);
    },
    // 下拉刷新
    bsPullingDown() {
      this.currentPage = 1;
      setTimeout(() => {
        this.getTopicList('pullDown');
      }, 10);
    },
    // 绑定账号
    bindAccount() {
      this.CHANGE_BIND_GAME(true);
    },
    // 监听滚动事件，确定什么时候新游推荐以及固定tabs
    handleScroll(pos) {
      this.bsScrollTop = pos.y;
      this.showFixedTabs = pos.y <= -256;
      if (this.bsScrollTop > 100) {
        this.$refs.newGameWrapper.openNewGame();
      }
    },
    // 回到顶部
    scrollToTop() {
      this.$refs.scroll.scrollTo(0, 0, 1000);
    },
    // 添加帖子
    addTopic() {
      reportData({
        type: 3,
        data_type: 3,
        circle_id: this.circleId,
      });
      if (!this.isRegister) {
        this.CHANGE_REGISTER_DIALOG(true);
        return;
      }
      this.showTopicField = true;
    },
    // 被封号的时候弹出一个弹窗
    showProhibitionDialog() {
      const prohibition = this.userInfo.prohibition;
      if (prohibition.state_type == 1) {
        let warnMsg = `您的论坛账号已被封禁\n 封禁时间：${
          prohibition.time_type == 1 ? '永久' : prohibition.start_time + '~' + prohibition.end_time
        }\n如有疑问请联系客服`;
        Dialog.alert({
          title: '温馨提示',
          message: warnMsg,
        }).then(() => {
          this.$router.push({ name: 'gameCircleCenter.home' });
        });
        return;
      }
    },
  },
};
</script>

<style lang="scss" module>
@import '~@/styles/mixins.scss';
.box {
  width: 100%;
  height: auto;
  .suspend-btn {
    position: absolute;
    right: 10px;
    bottom: 75px;
    z-index: 20;
    display: flex;
    flex-direction: column;
    img {
      width: 53px;
      height: 53px;
    }
  }
  .wrapper {
    position: relative;
    width: 100%;
    height: calc(100vh - 94px);
    .content {
      min-height: 100vh;
      .refresh {
        position: absolute;
        top: -25px;
        z-index: 5;
        width: 100%;
        height: 20px;
        text-align: center;
        font-size: 12px;
        color: #9f9f9f;
      }
      .top-banner {
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
      }
      .circle {
        position: relative;
        padding-top: 100px;
        padding-bottom: 7px;
        background: {
          size: 100% auto;
          repeat: no-repeat;
        }
        .circle-content {
          position: relative;
          z-index: 3;
          margin: 0 7px 7px 7px;
          padding: 8px 10px;
          background: #ffffff;
          border-radius: 7px;
          box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.03);
          .circle-info {
            display: flex;
            align-items: center;
            font-size: 11px;
            > img {
              width: 54px;
              height: 54px;
              border-radius: 15px;
              margin-right: 7px;
            }
            .circle-account {
              > p {
                font-size: 14px;
                font-weight: 400;
                margin-bottom: 12px;
                &.active {
                  margin-top: 1px;
                  font-size: 12px;
                  font-weight: bold;
                  margin-bottom: 3px;
                }
              }
              .no-bind-account {
                display: flex;
                align-items: center;
                > span {
                  color: #fe0000;
                }
                :global {
                  .hm-small-btn {
                    font-size: 8px;
                    background: #45aff3;
                    vertical-align: middle;
                    margin-left: 8px;
                    margin-bottom: 1px;
                  }
                }
              }
            }
          }
          .circle-navbar {
            font-size: 12px;
            margin-top: 18px;
            color: #9f9f9f;
            padding-bottom: 12px;
            display: flex;
            li {
              display: inline-block;
              margin-right: 40px;
              &.noMargin {
                margin-right: 0;
              }
            }
            img {
              width: 26px;
              height: 26px;
              display: block;
              margin: auto;
              margin-bottom: 3px;
            }
          }
        }
      }
      .list {
        position: relative;
        z-index: 3;
        .tabs {
          width: 100%;
          height: 44px;
        }
        .top-topic-list {
          @include border-bottom-1px;
          padding: 10px 17px;
          background: #ffffff;
          font-size: 14px;
          li {
            margin: 10px 0;
            display: flex;
            align-items: center;
            > p {
              @include ellipsis(1);
            }
          }
          .tag {
            width: 30px;
            height: 16px;
            background: linear-gradient(-90deg, rgba(255, 168, 62, 1), rgba(255, 214, 62, 1));
            border-radius: 2px;
            color: #ffffff;
            font-size: 11px;
            line-height: 16px;
            text-align: center;
            padding: 0 3px;
            display: inline-block;
            margin-right: 4px;
          }
          .mark {
            color: red;
            font-weight: bold;
          }
        }
        .topic-list {
          div:last-child {
            &::before {
              border-top: none !important;
            }
          }
        }
      }
      .no-more-topic {
        width: 100%;
        height: 30px;
        display: flex;
        justify-content: center;
        color: #9f9f9f;
        font-size: 11px;
        padding: 10px 0;
      }
    }
    .fix-tabs {
      position: fixed;
      top: 44px;
      z-index: 6;
      width: 100%;
      height: 44px;
      background-color: #fff;
    }
  }
}
</style>
